export default [
    {
        name: 'WebGL',
        width: '80%',
    },
    {
        name: 'Javascript',
        width: '85%',
    },
    {
        name: 'Solidity',
        width: '90%',
    },
    {
        name: 'Socket.io',
        width: '70%'
    },
    {
        name: 'HTML',
        width: '90%',
    },
]